import type { AuditRowState } from './auditStudioDerived';
import type { GradedWork } from '../types';

/** Queue / badge states for the submission grading screen. */
export type SubmissionDisplayState =
  | 'ungraded'
  | 'draft'
  | 'finalized'
  | 'missing'
  | 'late'
  | 'error';

export function getSubmissionDisplayState(
  w: GradedWork,
  auditState: AuditRowState
): SubmissionDisplayState {
  if (auditState === 'error') {
    return (w.imageUrls?.length ?? 0) === 0 ? 'missing' : 'error';
  }
  if (auditState === 'ready') return 'finalized';
  const hasScore = typeof w.score === 'number' && !Number.isNaN(w.score);
  const hasFeedback = (w.feedback || '').trim().length > 0;
  if (!hasScore && !hasFeedback) return 'ungraded';
  if (w.scanHealth !== undefined && w.scanHealth < 0.35) return 'late';
  return 'draft';
}
